/*! @azure/msal-common v13.3.3 2024-06-06 */
'use strict';

import { SERVER_TELEM_CONSTANTS } from '../../utils/Constants.js';

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var ServerTelemetryEntity = /** @class */function () {
  function ServerTelemetryEntity() {
    this.failedRequests = [];
    this.errors = [];
    this.cacheHits = 0;
  }
  /**
   * validates if a given cache entry is "Telemetry", parses <key,value>
   * @param key
   * @param entity
   */
  ServerTelemetryEntity.isServerTelemetryEntity = function (key, entity) {
    var validateKey = key.indexOf(SERVER_TELEM_CONSTANTS.CACHE_KEY) === 0;
    var validateEntity = true;
    if (entity) {
      validateEntity = entity.hasOwnProperty("failedRequests") && entity.hasOwnProperty("errors") && entity.hasOwnProperty("cacheHits");
    }
    return validateKey && validateEntity;
  };
  return ServerTelemetryEntity;
}();
export { ServerTelemetryEntity };